<template>
  <div class="tuolele-course-details">
    <div class="course-title">{{ dataInfo.title }}</div>
    <div class="course-time">{{ dataInfo.modify_time }}</div>
    <div v-if="dataInfo.type == 2" class="course-content">
      <video id="video" :src="videoObj.file_url" controls="controls" />
    </div>
    <div v-else class="course-content wordWrap" v-html="dataInfo.content" />
    <div
      v-if="dataInfo.attachments && dataInfo.attachments.length > 0"
      class="course-file fn-clear"
    >
      <div class="fn-left">附件</div>
      <div class="file-list">
        <div
          v-for="item in dataInfo.attachments"
          :key="item.id"
          class="file-item"
        >
          <span>{{ `${item.name}.${item.file_suffix}` }}</span>
          <el-button
            type="primary"
            @click="downloadFile(item.file_url)"
          >下载</el-button>
        </div>
      </div>
    </div>
    <div
      v-if="
        dataInfo.near_article.previous_post || dataInfo.near_article.next_post
      "
      class="course-near"
    >
      <div class="fn-clear">
        <span class="fn-left">上一篇</span>
        <i
          class="fn-left"
          @click="toOtherCourse(dataInfo.near_article.previous_post.id)"
        >{{ dataInfo.near_article.previous_post.title }}</i>
      </div>
      <div class="fn-clear">
        <span class="fn-left">下一篇</span>
        <i
          class="fn-left"
          @click="toOtherCourse(dataInfo.near_article.next_post.id)"
        >{{ dataInfo.near_article.next_post.title }}</i>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
export default {
  name: 'TuoleleCourseDetails',
  data() {
    return {
      dataInfo: {
        near_article: {
          previous_post: {},
          next_post: {}
        }
      },
      videoObj: {}
    }
  },
  watch: {
    $route() {
      const id = this.$route.query.id
      this.getArticleShow(id)
    }
  },
  mounted() {
    const id = this.$route.query.id
    this.getArticleShow(id)
  },
  methods: {
    async getArticleShow(id) {
      const ret = await this.$http.getArticleShow({ id })
      if (ret.code == 200) {
        this.dataInfo = ret.data
        if (this.dataInfo.files && this.dataInfo.files.length > 0) {
          this.videoObj = this.dataInfo.files[0]
        }
      }
    },
    toOtherCourse(id) {
      this.$router.push({
        path: 'tuoleleCourseDetails',
        query: { id }
      })
    },
    downloadFile(url) {
      FileSaver.saveAs(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.tuolele-course-details {
  box-shadow: 0px 6px 20px 0px #3a5798;
  background-color: #fff;
  border-radius: 10px;
  padding: 60px;
  .course-title {
    font-size: 30px;
    color: $color_black;
    margin-bottom: 10px;
  }
  .course-time {
    font-size: 14px;
    color: $color_normal;
    margin-bottom: 30px;
  }
  .course-content {
    font-size: 14px;
    color: $color_black;
    margin-bottom: 30px;
    #video {
      width: 900px;
    }
    img {
      max-width: 100%;
    }
  }
  .course-file {
    border-top: 1px solid #f5f5f5;
    padding: 40px 0 20px 0;
    .fn-left {
      color: $color_black;
      font-size: 16px;
      line-height: 40px;
      width: 3em;
    }
    .file-list {
      padding-left: 20px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      .file-item {
        line-height: 40px;
        width: 33%;
        margin-bottom: 20px;
        font-size: 14px;
        color: $color_blue;
      }
    }
  }
  .course-near {
    border-top: 1px solid #f5f5f5;
    padding: 40px 0 20px 0;
    line-height: 16px;
    div {
      margin-bottom: 20px;
      span {
        color: $color_black;
        font-size: 16px;
        margin-right: 20px;
      }
      i {
        color: $color_blue;
        font-size: 14px;
        font-style: normal;
        cursor: pointer;
      }
    }
  }
}

.el-button.el-button--primary {
  width: 90px;
  height: 40px;
  margin-left: 35px;
}
</style>
